import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useAuthDispatch } from "../../Context";

export default function MediaCard({ data }) {
  // console.log("dashboard data",data)
  const navigate = useNavigate();
  const dispatch = useAuthDispatch();
  const handleViewClick = () => {
    const path = `/dashboard/${data.site}-${data.workbook_url}-${data.viewUrlName}`;
    navigate(path, {
      state: { view: data.viewUrlName, workbook_url: data.workbook_url, site: data.site },
    });
    dispatch({ type: "NAVIGATE", payload: path });
  };
  return (
    <Card sx={{ width: 265 }} data-testid="dashboard-card">
      <CardMedia
        sx={{ height: 200, backgroundSize: "contain" }}
        image={`data:image/gif;base64,${data.image_data}`}
        title={data.view}
      />
      <CardContent sx={{ pb: 0, '&:last-child': { pb: 0 } }}>
        <Typography
          gutterBottom
          variant="h6"
          component="div"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            height: "4rem", // Adjust based on your theme's typography h6 line-height and desired spacing
            textOverflow: "ellipsis",
          }}
        >
          {data.tile_name}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 6, // Adjust the number of lines you want to show before truncating
            textOverflow: "ellipsis",
            height: "8rem", // Adjust based on your desired height
          }}
        >
          {data.description}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <Button
          size="small"
          onClick={handleViewClick}
          sx={{ textTransform: "none", fontSize: "16px" }}
        >
          View
        </Button>
      </CardActions>
    </Card>
  );
}
